



















import { Component, Vue, Emit, Prop } from 'nuxt-property-decorator'
import ModalWrapper from '~/components/shared/modalWrapper/ModalWrapper.vue'
import ImagesGallery from '~/components/shared/imagesGallery.vue'

@Component({
  components: {
    ModalWrapper,
    ImagesGallery,
  },
})
export default class VirtualTourWrapper extends Vue {
  @Prop({ default: [] }) images: Array<string>

  @Emit('setShowImageGallery')
  onClose(): boolean {
    return false
  }
}
